import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft } from "lucide-react";

const FIELDS = [
  ["shop_name", "Shop name"],
  ["address1", "Address line 1"],
  ["address2", "Address line 2"],
  ["address3", "Address line 3"],
  ["gst_no", "GST No"],
  ["cin_no", "CIN No"],
  ["counter_no", "Counter No"],
  ["session_no", "Session No"],
  ["phone", "Phone"],
  ["reg_office1", "Registered office line 1"],
  ["reg_office2", "Registered office line 2"],
  ["email", "Email"],
];

export default function Settings() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [form, setForm] = useState({});

  useEffect(() => {
    if (user && user.role !== "admin") navigate("/");
  }, [user, navigate]);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data || {}));
  }, []);

  const save = async () => {
    try {
      await api.put("/settings", form);
      toast.success("Store settings saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Save failed");
    }
  };

  return (
    <div className="pos-shell">
      <div className="pos-titlebar">
        <span>Store Settings</span>
        <div className="right">
          <button className="title-btn" onClick={() => navigate("/")} data-testid="back-pos">
            <ArrowLeft size={13} style={{ display: "inline", marginRight: 4 }} />
            Back to POS
          </button>
        </div>
      </div>
      <div style={{ flex: 1, overflow: "auto", padding: 16, maxWidth: 560 }}>
        {FIELDS.map(([key, label]) => (
          <div key={key} style={{ marginBottom: 10 }}>
            <label className="login-label">{label}</label>
            <Input
              value={form[key] || ""}
              onChange={(e) => setForm({ ...form, [key]: e.target.value })}
              data-testid={`settings-${key}`}
            />
          </div>
        ))}
        <Button onClick={save} data-testid="settings-save" style={{ marginTop: 8 }}>
          Save Settings
        </Button>
      </div>
    </div>
  );
}
